"use client";

import React, { createContext, useContext } from "react";
import { useCollaboratorSession } from "@/hooks/useCollaboratorSession";

interface CollaboratorSessionContextValue {
  status: "active" | "paused" | "offline";
  /** false cuando no se pudo leer el estado, que no es lo mismo que offline. */
  statusConocido: boolean;
  isOnline: boolean;
  isPaused: boolean;
  togglePause: () => void;
  isLoading: boolean;
  currentBaseId: number | null;
  currentBase: { id: number; name: string; CRPC?: string | null } | null;
  changeBase: (baseId: number) => void;
  loginWithBase: (baseId: number) => void;
}

const CollaboratorSessionContext =
  createContext<CollaboratorSessionContextValue | null>(null);

export function CollaboratorSessionProvider({
  children,
  baseId,
}: {
  children: React.ReactNode;
  baseId?: number;
}) {
  const session = useCollaboratorSession(baseId);

  return (
    <CollaboratorSessionContext.Provider value={session}>
      {children}
    </CollaboratorSessionContext.Provider>
  );
}

/**
 * Wrapper that conditionally enables the CollaboratorSession provider.
 * When not enabled, renders children without the provider.
 */
export function CollaboratorSessionWrapper({
  children,
  enabled,
}: {
  children: React.ReactNode;
  enabled: boolean;
}) {
  if (!enabled) return <>{children}</>;
  return <CollaboratorSessionProvider>{children}</CollaboratorSessionProvider>;
}

export function useCollaboratorSessionContext() {
  return useContext(CollaboratorSessionContext);
}
